import(/* webpackMode: "eager" */ "/codebuild/output/src889301559/src/scaleup-applications/apps/scaleup-platform-ui/app/[...slug]/page.tsx");
